import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import ShipmentChart from '../../components/ShipmentChart';

@inject('deliveryStore')
@observer
class ShipmentsStats extends Component {
  render() {
    const { deliveryStore } = this.props
    const { start, stats = {} } = deliveryStore;
    return <ShipmentChart date = {start * 1000} stats = {stats} onCollapse={this.props.onCollapse} />
  }
}

export default ShipmentsStats
